module.exports = __webpack_public_path__ + "img/banner_3.b8da20cb.jpg";